import type { FC } from 'react';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { removeCouponCreateV2ById, selectCreatedCouponsV2, selectorCouponHistoryCategoriesObjV2, selectorCouponHistoryChampionshipsObjV2, selectorCouponHistorySportsObjV2,
// useAccessCookie,
useLocalizedNumberFormatters, useTimezoneDate, useToggle } from '@mwl/core-lib';
import ArrowIcon from '@public/assets/common/icons/arrow.svg';
import { Button } from '@/components/Button/Button';
// import { SportHistoryCashOutButton } from '@/components/SportHistoryCashOutButton/SportHistoryCashOutButton';
// import { SportHistoryInsuranceButton } from '@/components/SportHistoryInsuranceButton/SportHistoryInsuranceButton';
import { useTypedDispatch, useTypedSelector } from '@/hooks';

// import { getShowCashOutOffer, getShowInsuranceOffer } from '@/utils/sport';
// import type { OnUpdateCouponInPagesById } from '@/types';
import { couponTypeTranslations } from '../../SportCoupon.data';
import { CouponBet } from '../CouponBet/CouponBet';
import type { CouponBetsHistoryItemProps } from './CouponBetsHistoryItem.types';
import styles from './CouponBetsHistoryItem.module.scss';
const CouponBetsHistoryItemBase: FC<CouponBetsHistoryItemProps> = initialCoupon => {
  const dispatch = useTypedDispatch();
  const [coupon] = useState(initialCoupon);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const {
    status,
    winningAmount,
    possibleOdds,
    calculationOdds,
    bets,
    createdAt,
    displayId,
    type,
    betAmount,
    systemBase
  } = coupon;
  const {
    t
  } = useTranslation('sport');
  const championshipsObj = useTypedSelector(selectorCouponHistoryChampionshipsObjV2);
  const sportsObj = useTypedSelector(selectorCouponHistorySportsObjV2);
  const categoriesObj = useTypedSelector(selectorCouponHistoryCategoriesObjV2);
  const createdCoupons = useTypedSelector(selectCreatedCouponsV2);
  const [isOpened, toggleIsOpened] = useToggle(false);
  const {
    formatPriceByCurrencyCodeWithLocale
  } = useLocalizedNumberFormatters({
    minimumFractionDigits: 2
  });
  const {
    formatter
  } = useTimezoneDate({
    format: "dd.MM.yyyy' ('HH':'mm':'ss')'"
  });

  // const showInsuranceOffer = getShowInsuranceOffer(coupon);
  // const showCashOutOffer = getShowCashOutOffer(coupon);

  // const hasInsuranceAccess = useAccessCookie('sport_history_insurance');
  // const hasCashOutAccess = Boolean(useAccessCookie('sport_history_cash-out'));
  // const showActions = hasInsuranceAccess || hasCashOutAccess;

  // const onUpdateCoupon: OnUpdateCouponInPagesById = useCallback(
  //   (_, nextCoupon) => setCoupon((prevCoupon) => ({ ...prevCoupon, ...nextCoupon })),
  //   [],
  // );

  const handleSelectOpen = () => {
    toggleIsOpened();
  };
  const formatedDate = useMemo(() => {
    if (!createdAt) {
      return null;
    }
    const currentDate = new Date(createdAt);
    return formatter(currentDate);
  }, [createdAt, formatter]);
  const isNewCoupon = useMemo(() => {
    return createdCoupons.find(createdCoupon => createdCoupon.id === coupon.id)?.status === 'OPENED';
  }, [createdCoupons, coupon.id]);
  useEffect(() => {
    if (isNewCoupon) {
      timer.current = setTimeout(() => {
        dispatch(removeCouponCreateV2ById(coupon.id));
      }, 2000);
    }
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewCoupon]);
  if (status !== 'OPENED') {
    return null;
  }
  return <div className={cn(styles.root, {
    [styles.new]: isNewCoupon
  })} data-sentry-component="CouponBetsHistoryItemBase" data-sentry-source-file="CouponBetsHistoryItem.tsx">
      <Button as="button" type="button" variant="text" onClick={handleSelectOpen} fullWidth className={styles.title} uppercase={false} data-sentry-element="Button" data-sentry-source-file="CouponBetsHistoryItem.tsx">
        <div className={styles.titleWrapper}>
          <div className={styles.idDateWrapper}>
            <span className={styles.idWrapper}>
              <Trans key="coupon.history.item_id" t={t} values={{
              displayId
            }} components={[<span key={0} className={styles.idNumber} />]} data-sentry-element="Trans" data-sentry-source-file="CouponBetsHistoryItem.tsx">
                {'ID:<0>{{displayId}}<0>'}
              </Trans>
            </span>

            <span className={styles.createdAt}>{formatedDate}</span>
          </div>
          <div className={styles.typeWrapper}>
            {type && <div className={styles.couponType}>
                {t(couponTypeTranslations[type])}
                {type === 'SYSTEM' && systemBase ? ` ${systemBase}/${bets.length}` : ''}
              </div>}
            <div className={styles.titleIconWrapper}>
              <ArrowIcon width={16} height={16} className={cn(styles.titleIcon, {
              [styles.isOpened]: isOpened
            })} data-sentry-element="ArrowIcon" data-sentry-source-file="CouponBetsHistoryItem.tsx" />
            </div>
          </div>
        </div>
        <div className={styles.dataLine}>
          <span>{t('coupon.stake_amount', 'Stake amount')}</span>
          {betAmount && <span className={cn(styles.lineValue, styles.stakeAmountValue)}>
              {formatPriceByCurrencyCodeWithLocale(betAmount.amount, betAmount.currency)}
            </span>}
        </div>
      </Button>
      <div className={styles.contentOuter} style={{
      height: isOpened ? contentRef.current?.offsetHeight : 0
    }}>
        <div className={styles.contentInner} ref={contentRef}>
          {/* {showActions && (
            <div className={styles.actions}>
              {hasInsuranceAccess && (
                <SportHistoryInsuranceButton
                  className={styles.actionButton}
                  hidden={!showInsuranceOffer}
                  coupon={coupon}
                  onInsure={onUpdateCoupon}
                />
              )}
               {hasCashOutAccess && (
                <SportHistoryCashOutButton
                  className={styles.actionButton}
                  hidden={!showCashOutOffer}
                  coupon={coupon}
                  onCashOut={onUpdateCoupon}
                />
              )}
            </div>
           )} */}
          <div className={styles.betsWrapper}>
            {!!bets?.length && bets.map((bet, index) => {
            const championship = bet.championshipId ? championshipsObj[bet.championshipId] : undefined;
            const sport = bet.sportId ? sportsObj[bet.sportId] : undefined;
            const category = bet.categoryId ? categoriesObj[bet.categoryId] : undefined;
            return <CouponBet {...bet} withRefuse={false} championship={championship} sport={sport} category={category} key={bet?.outcome?.id || index} />;
          })}
          </div>
          <div className={styles.footer}>
            {(calculationOdds != null || possibleOdds != null) && <div className={cn(styles.dataLine, styles.coefficient)}>
                <span>{t('coupon.final_coeff', 'Final coefficient:')}</span>
                <span className={cn(styles.lineValue, styles.redColor)}>{calculationOdds || possibleOdds}</span>
              </div>}
            {!!winningAmount && <div className={cn(styles.dataLine, styles.winning)}>
                <span>{t('coupon.history.item_winning', 'Winning:')}</span>
                <span className={cn(styles.lineValue, styles.yellowColor)}>
                  {formatPriceByCurrencyCodeWithLocale(winningAmount.amount, winningAmount.currency)}
                </span>
              </div>}
            {status && <div className={cn(styles.dataLine, styles.status)}>
                <span>{t('coupon.history.item_status', 'Status:')}</span>
                <span className={cn(styles.lineValue, styles.greenColor)}>
                  {t('coupon.history.item_status_value', 'OPEN')}
                </span>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
const CouponBetsHistoryItem = memo(CouponBetsHistoryItemBase);
CouponBetsHistoryItem.displayName = 'CouponBetsHistoryItem';
export { CouponBetsHistoryItem };